import marketMobileBg from '@/assets/images/styleFilterMarket/marketMobileBg.png';
import { ChevLeftIcon } from '@/components/Icons';
import { Badge } from '@/components/ui/badge';
import { useNavigate } from 'react-router-dom';
import AvatarImage from '@/assets/images/styleFilterMarket/AvatarImage.png';
import { StyleFilterArtistDetail } from '@/service/type/Filter';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

export function MarketArtiestHeader({ data }: { data?: StyleFilterArtistDetail }) {
  const navigate = useNavigate();

  return (
    <section className="relative h-[470px] flex flex-col items-center text-center">
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          background: `url(${marketMobileBg}) 0% 0% / cover no-repeat`,
        }}
      >
        <div className="absolute inset-0" />
      </div>
      <div
        className="relative z-10 container mx-auto px-6 mt-6 flex items-center gap-2"
        onClick={() => {
          navigate('/marketplace');
        }}
      >
        <Badge
          variant="secondary"
          className="h-[2.5rem] w-[2.5rem] text-[#fff] cursor-pointer bg-white bg-opacity-20 hover:bg-white/60 backdrop-blur-md"
        >
          <ChevLeftIcon className="scale-[2]" fillColor="currentColor" />
        </Badge>
        <span className="text-white text-[1rem]">Back</span>
      </div>
      <div className="relative z-10 container mx-auto px-4 mt-20">
        <h1 className="font-normal text-white leading-[100%] text-[2rem]">
          Make Music in the <br />
          Style of Imogen Heap
        </h1>
        <div className="flex flex-wrap justify-center gap-2 mt-4">
          {['Alternative Pop', 'Ambient', 'Instrumental', 'Electronic'].map((tag) => (
            <Badge
              key={tag}
              variant="secondary"
              className="text-white text-[14px] cursor-pointer bg-white bg-opacity-40 hover:bg-white hover:bg-opacity-60 backdrop-blur-md"
              style={{ fontWeight: '400' }}
            >
              {tag}
            </Badge>
          ))}
        </div>
      </div>
      <div className="absolute overflow-hidden w-[5.3rem] aspect-square shrink-0 left-[20px] bottom-[-40px]">
        <Avatar className="w-full h-full border-2 border-white">
          <img src={AvatarImage} alt="Avatar" className="w-full h-full object-cover" />
          <AvatarFallback>{data?.name.slice(0, 2)}</AvatarFallback>
        </Avatar>
        <div className="absolute top-[1px] right-[1px]">
          <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.2656 1.70312C13.8848 1.75291 14.4941 1.97717 15.0137 2.37695L15.0127 2.37793L15.8564 3.02441L16.918 2.88574L17.1953 2.86133C18.4857 2.8004 19.6937 3.50038 20.2852 4.64551L20.4023 4.89746L20.4033 4.89844L20.8086 5.88281L21.792 6.28906L21.7939 6.29004H21.7949C23.0884 6.82668 23.8964 8.11586 23.8311 9.49805L23.8066 9.77539L23.667 10.833L24.3164 11.6797L24.4385 11.8496C24.7092 12.2523 24.8822 12.701 24.957 13.1621L24.9912 13.4512C25.0054 13.645 25.0025 13.8397 24.9824 14.0332L24.9395 14.3213C24.8561 14.7518 24.6861 15.1692 24.4307 15.5459L24.3164 15.7051L23.667 16.5508L23.8066 17.6094L23.8311 17.8867C23.892 19.1767 23.1929 20.3858 22.0479 20.9775L21.7949 21.0947H21.793L21.792 21.0957L20.8086 21.501L20.4033 22.4863L20.4023 22.4873C19.8659 23.7804 18.5777 24.5887 17.1953 24.5234L16.918 24.499L15.8564 24.3594L15.0127 25.0068L15.0137 25.0078C14.4941 25.4076 13.8848 25.6319 13.2656 25.6816L13 25.6924C12.2909 25.6925 11.5801 25.4647 10.9863 25.0078V25.0068L10.1426 24.3594L9.08203 24.499C7.59728 24.6946 6.16984 23.8666 5.59766 22.4873L5.59668 22.4863L5.19043 21.501L4.20801 21.0957H4.20703L4.20508 21.0947C2.82547 20.5223 1.99777 19.0938 2.19336 17.6094L2.33203 16.5508L1.68359 15.7051C1.35849 15.2817 1.14879 14.7982 1.05566 14.2979L1.02344 14.082C0.924461 13.2475 1.14448 12.3818 1.68359 11.6797L2.33203 10.833L2.19336 9.77539C1.99777 8.29097 2.82547 6.86243 4.20508 6.29004H4.20703L4.20801 6.28906L5.19043 5.88281L5.59668 4.89844L5.59766 4.89746L5.71484 4.64551C6.34849 3.41866 7.68996 2.70238 9.08203 2.88574L10.1426 3.02441L10.9863 2.37793V2.37695C11.5801 1.92009 12.2909 1.69226 13 1.69238L13.2656 1.70312Z"
              fill="#FF5B27"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.2071 11.8995C17.5976 11.509 17.5976 10.8758 17.2071 10.4853C16.8166 10.0948 16.1834 10.0948 15.7929 10.4853L12 14.2782L10.7071 12.9853C10.3166 12.5948 9.68342 12.5948 9.29289 12.9853C8.90237 13.3758 8.90237 14.009 9.29289 14.3995L11.2929 16.3995C11.6834 16.79 12.3166 16.79 12.7071 16.3995L17.2071 11.8995Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}
